import FinanceSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class LedgerItem extends FinanceSerializer {
  normalize(modelClass, payload) {
    payload.defaultAmount = ((payload.defaultAmount ?? 0) / 100).toFixed(2);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.ledgerId = parseInt(hash.ledgerId, 10);
    if (!isEmpty(hash.costCentreId)) {
      hash.costCentreId = parseInt(hash.costCentreId, 10);
    }
    if (!isEmpty(hash.internalOrderId)) {
      hash.internalOrderId = parseInt(hash.internalOrderId, 10);
    }
    hash.defaultAmount = Math.round(hash.defaultAmount * 100);
    return hash;
  }
}
